import { useEffect, useState } from "react";
import FormCustom from "../common/FormCustom";
import InputField from "../common/InputField";
import { Select, SelectItem } from "@nextui-org/react";
import ButtonCustom from "../common/ButtomCustom";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useCreateUserApi, useGetAllRoleApi } from "../../hooks";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";
import { useCommonStore } from "../../store";

const ROLES = [
  {
    label: "ROLE_ADMIN",
    key: "ROLE_ADMIN",
    value: "ROLE_ADMIN",
  },
  {
    label: "ROLE_USER",
    key: "ROLE_USER",
    value: "ROLE_USER",
  },
  {
    label: "ROLE_INVERTOR",
    key: "ROLE_INVERTOR",
    value: "ROLE_INVERTOR",
  },
];

const CreateUserForm: React.FC<any> = ({ onClose }: any) => {
  // state
  const [value, setValue] = useState<Set<string>>(new Set());

  const { reload, setReload } = useCommonStore();

  // api
  const { mutate: $createUser, isPending } = useCreateUserApi();

  // navigate
  const navigate = useNavigate();

  const onSubmitHandleCreateUser = (data: any) => {
    $createUser(
      { ...data, role: Array.from(value)[0] },
      {
        onSuccess: (response: any) => {
          if (response?.code === 200) {
            toast.success("Tạo người dùng mới thành công !");
            navigate(path.USER_MANAGER);
            setReload(!reload);
            onClose();
          } else {
            toast.error(response?.error || "Tạo người dùng mới thất bại !");
          }
        },
      }
    );
  };

  return (
    <FormCustom onSubmitHandle={onSubmitHandleCreateUser}>
      {(methods) => (
        <>
          <InputField
            label="First Name"
            type="text"
            name="firstName"
            register={methods.register}
            validate={{
              required: "Enter your first name",
              minLength: {
                value: 2,
                message: "First name must be at least 2 characters",
              },
            }}
            error={methods.formState.errors.firstName}
          />

          <InputField
            label="Last Name"
            type="text"
            name="lastName"
            register={methods.register}
            validate={{
              required: "Enter your last name",
              minLength: {
                value: 2,
                message: "Last name must be at least 2 characters",
              },
            }}
            error={methods.formState.errors.lastName}
          />

          <InputField
            label="Phone number"
            type="text"
            name="phoneNumber"
            register={methods.register}
            validate={{
              required: "Enter your phone number",
              pattern: {
                value: /^\+?[0-9]{10,15}$/,
                message:
                  "Invalid phone number. Please enter between 10 and 15 digits and may begin with a + sign",
              },
            }}
            error={methods.formState.errors.phoneNumber}
          />

          <InputField
            label="Email"
            type="email"
            name="email"
            register={methods.register}
            validate={{
              required: "Enter your email",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Email not invalid",
              },
            }}
            error={methods.formState.errors.email}
          />

          <InputField
            label="Password"
            type="password"
            name="password"
            register={methods.register}
            validate={{
              required: "Enter your password",
              minLength: {
                value: 6,
                message: "Password must have at least 6 characters",
              },
            }}
            error={methods.formState.errors.password}
          />

          <Select
            label="Role"
            variant="bordered"
            selectedKeys={value}
            className="w-[100%] mt-1"
            size="sm"
            onSelectionChange={(keys) => {
              if (keys.currentKey) {
                setValue(new Set([keys.currentKey]));
              }
            }}
          >
            {ROLES.map((role: any) => (
              <SelectItem key={role.key}>{role.label}</SelectItem>
            ))}
          </Select>

          <div className="w-[100%] flex justify-end">
            <ButtonCustom
              variant="primary"
              size="md"
              className="bg-[#b1b0b0] hover:bg-opacity-80 text-sm md:text-md md:py-3 gap-2 md:mt-0 mt-2 w-[100%] hover:bg-ok-travel-green-light text-white"
            >
              {isPending && (
                <Spin
                  indicator={
                    <LoadingOutlined className="white-spinner-icon" spin />
                  }
                  size="small"
                />
              )}
              <span>Create New User</span>
            </ButtonCustom>
          </div>
        </>
      )}
    </FormCustom>
  );
};

export default CreateUserForm;
